import { useEffect } from "react";
import { API_SERVICEPROVIDERS } from "../api/api";
import sessionStorageKeys from "../browser/sessionStorageKeys";
import { selectUser } from "../context/slices/userProfileSlice";
import { useXNGSelector } from "../context/store";
import { msalAccount } from "./msalEventCallback";

/**
 * Custom hook that syncs user data to North Pass groups.
 * Separated from auth provider for better separation of concerns.
 */
export function useNorthPassSync() {
  const user = useXNGSelector(selectUser);
  const northPassSession = sessionStorage.getItem(sessionStorageKeys.NORTH_PASS_KEY);

  useEffect(() => {
    const setNorthPass = async () => {
      const syncUserData = await API_SERVICEPROVIDERS.v1SyncUserToGroups(
        user?.id!,
        user?.emailAddress ?? "",
        (msalAccount?.idTokenClaims as any)?.state,
        {},
      );
      if (syncUserData) {
        sessionStorage.setItem(sessionStorageKeys.NORTH_PASS_KEY, "true");
      }
    };

    if (!northPassSession && user?.emailAddress && msalAccount?.idTokenClaims?.state) {
      setNorthPass();
    }
  }, [northPassSession, user]);
}
